// Types
import LocalizedString from '@/types/localized-string';
import Locale from '@/types/locale';
import Nullable from '@/types/nullable';

// Utils
import { formatLocalizedString, LOCALE } from './i18n';
import { LABEL_FORMATTERS } from '@/utils/charts';

/**
 * Format the accessibility description
 * @param {LocalizedString} description The accessibility description
 * @param {Locale} locale Current locale
 * @param {string[]} items The items list in the description
 * @param {Nullable<Date>} startDate The period start date
 * @param {Nullable<Date>} endDate The period end date
 * @param {number} capital The growth value
 * @param {LocalizedString} period The period range
 * @returns {string} Formatted text
 */
export const formatAccessibilityDescription = (
  description: LocalizedString,
  locale?: Locale,
  items?: string[],
  startDate?: Nullable<Date>,
  endDate?: Nullable<Date>,
  capital?: number,
  period?: LocalizedString,
): string => {
  const { months } = LABEL_FORMATTERS.lang(locale || LOCALE.EN_CA);
  const startDateMonth = startDate && startDate?.getMonth() >= 0 ? months[startDate.getMonth()] : '';
  const startDateYear = startDate && startDate?.getFullYear() ? startDate.getFullYear() : '';
  const endDateMonth = endDate && endDate?.getMonth() >= 0 ? months[endDate.getMonth()] : '';
  const endDateYear = endDate && endDate?.getFullYear() ? endDate.getFullYear() : '';
  let formattedText = formatLocalizedString(description, locale || LOCALE.EN_CA);

  formattedText = formattedText
    ?.replace('{{items}}', `${items?.map(item => ` ${item}`) || ''}`)
    .replace('{{startDate}}', `${startDateMonth} ${startDateYear}`)
    .replace('{{endDate}}', `${endDateMonth} ${endDateYear}`)
    .replace('{{capital}}', `${capital || ''}`)
    .replace('{{period}}', `${period ? period[locale || LOCALE.EN_CA] : ''}`);

  return formattedText;
};
